import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amountConverter'
})
export class AmountConverterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
     return new Intl.NumberFormat(value, {
      minimumFractionDigits: 0
    }).format(Number(value));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/amount-converter.pipe.ts